import Container from "../../components/container";
import fetch from "isomorphic-fetch";
import config from "../../config.json";
import SearchComponent from '../../components/search';

const Search = ({menu})=>{
    return <Container menu={menu} noNewsletter={true} title={"Realizar una busqueda, Florería Detalles y Caprichos"} hiddenMobile={true} >
        <h1 className="title">Realiza una busqueda</h1>
        <SearchComponent />
    </Container>
};


export async function getServerSideProps(ctx){
    const resMenu = await fetch(`${config.api.uri}/v1/cat/menu/1?apikey=${config.api.apikey}`);
    const resJSONMenu = await resMenu.json();
    return {
        props:{
            menu: resJSONMenu
        }
    }
};


export default Search;